import * as React from "react";
import { Languages } from "lucide-react";
import { useT } from "../../../app/lib/i18n";
import { Button } from "../Button";
import * as s from "./LanguageToggle.css";

export type LanguageTogglePlacement = "fixed" | "header";

export interface LanguageToggleProps {
  flagUrl?: string | null;
  languageName?: string;
  onClick: () => void;
  placement?: LanguageTogglePlacement;
}

/**
 * Ghost icon button showing the current language flag (or a Languages icon).
 * Matches DarkModeToggle styling/placement conventions.
 */
export function LanguageToggle({
  flagUrl,
  languageName,
  onClick,
  placement = "fixed",
}: LanguageToggleProps) {
  const t = useT();
  return (
    <Button
      type="button"
      variant="ghost"
      color="neutral"
      size="sm"
      iconOnly
      className={s.wrapper[placement]}
      onClick={onClick}
      aria-label={
        languageName
          ? t("shared.languageToggle.changeLanguageNamed", { name: languageName })
          : t("shared.languageToggle.changeLanguage")
      }
    >
      {flagUrl ? (
        <img src={flagUrl} alt="" className={s.flagImg} aria-hidden />
      ) : (
        <Languages strokeWidth={1.75} aria-hidden />
      )}
    </Button>
  );
}
